export const prefixes = [
  'directParent',
  'ultimateParent',
  'relationship',
  'fundManager',
  'umbrellaFund',
  'masterFund',
  'headOffice',
]

export const mapPrefixes = (action) => {
  return prefixes.reduce((acc, prefix) => [ ...acc, ...action(prefix), ], [])
}



// WEBPACK FOOTER //
// ./src/utils/challenge/relationship.js